export const GET_ALL_DOCUMENTS = 'GET_ALL_DOCUMENTS';
export const GET_LATEST_ESTHIE_AGREEMENT_DOCUMENTS =
  'GET_LATEST_ESTHIE_AGREEMENT_DOCUMENTS';
export const SIGN_DOCUMENT_BY_ID = 'SIGN_DOCUMENT_BY_ID';
